import { takeLatest, take, put, call } from 'redux-saga/effects';

import { updateProfile } from 'store/actions/authActions';
import Api from 'api/auth';
import * as storage from 'utils/storage';
import { checkAuth } from './authSagas';

function* ensureUpdateAccount({ payload }) {
  try {
    const accessToken = JSON.parse(storage.getStorageItem('accessToken', '{}'));
    yield call(Api.updateAccount, {
      data: payload,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    yield call(checkAuth);
    yield put({ type: updateProfile.success });
  } catch (err) {
    yield put({ type: updateProfile.failure, err });
  }
}

export function* watchUpdateAccount() {
  yield takeLatest(updateProfile.type, ensureUpdateAccount);
  yield take(updateProfile.success);
}
